/* eslint-disable max-params */
export const throwTypeError = (
  componentName: string,
  validPropKey: string,
  invalidProp: unknown,
  validFormat: string,
): void => {
  throw new Error(
    `${componentName}:: You are trying to pass a not valid "${validPropKey}" property, 
    please provide a valid type.

  Received: ${invalidProp} (${typeof invalidProp})
  Expected: (${validFormat.replace('\n', ' or ')})
  `,
  );
};

export const throwRequiredError = (componentName: string, validPropKey: string): void => {
  throw new Error(
    `${componentName}:: Please provide a/an "${validPropKey}" property to use this component. 
     This property is required.
  `,
  );
};
